export const DISMISS_ALERT = 'ALERT::DISMISS_ALERT';
export const SHOW_ALERT = 'ALERT::SHOW_ALERT';



// WEBPACK FOOTER //
// ./src/reducers/alerts/constants.js